export default function removeModalBackdrop() {
  _removeModalBackdrop();
  _getModal().on('hidden.bs.modal', () => _removeModalBackdrop());
}

function _removeModalBackdrop() {
  if (!_getModalIn().length) {
    _getBackdrop().remove();
  }
}

function _getModal() {
  return $('.modal');
}

function _getModalIn() {
  return $('.modal.in');
}

function _getBackdrop() {
  return $('.modal-backdrop.in');
}



// WEBPACK FOOTER //
// ./client/app/common/utils/removeModalBackdrop.js